var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { Icon } from '@inter-ikea-kompis/component-icon';
import { Text } from '@inter-ikea-kompis/component-text';
import ToggleStyle from './ToggleStyle.js';
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 * This component is a toggle with toggle items inside it.
 *
 * @event select On select event.
 */
export default class Toggle extends KompisElement {
    constructor() {
        super(...arguments);
        // Index of selected item
        this.selectedIndex = 0;
        // Fill available width
        this.fluidWidth = false;
        // Toggle disabled
        this.disabled = false;
        // Label for the toggle group to set as an aria-label for accessibility reasons
        this.ariaLabel = null;
        this.hasFocus = false;
        this.focusIndex = 0;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        const direction = window.getComputedStyle(this).direction;
        return html `
			<style>
				${ToggleStyle.getStyle({
            selectedIndex: this.selectedIndex,
            fluidWidth: this.fluidWidth,
            numberOfItems: this.items.length,
            disabled: this.disabled,
            theme: this.theme,
            direction: direction,
            hasFocus: this.hasFocus,
            focusIndex: this.focusIndex
        })}
			</style>
			<div role="group" aria-label="${this.ariaLabel || ''}" class="container">
				${this.getItems()}
			</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-text', Text);
        this.customElements.define('kompis-icon', Icon);
        super.connectedCallback();
    }
    /**
     * Get button items in toggle.
     *
     * @returns Template.
     */
    getItems() {
        return html `${this.items.map((item, index) => html `<button
					id="item-${index}"
					@click="${() => this.dispatchEvent(new CustomEvent('select', { bubbles: true, detail: { selectedIndex: index } }))}"
					@mousedown="${this.onMouseDown.bind(this)}"
					@focusin="${() => this.onFocusIn(index)}"
					@focusout="${this.onFocusOut.bind(this)}"
					?disabled="${this.disabled}"
					aria-pressed="${this.selectedIndex === index}"
				>
					<div id="outline-${index}"></div>
					${this.getIcon(index)}
					<kompis-text
						.theme="${this.theme}"
						.bold="${true}"
						.type="${ThemeFontStyleTypeEnum.bodySmall}"
					>
						${item.label}
					</kompis-text>
				</button>`)}`;
    }
    /**
     * Returns icon.
     *
     * @param index ...
     * @returns Template.
     */
    getIcon(index) {
        if (!this.items[index].icon) {
            return null;
        }
        return html ` <kompis-icon
				.theme="${this.theme}"
				.icon="${this.items[index].icon}"
			></kompis-icon>
			<div class="icon-divider"></div>`;
    }
    /**
     * Event handler.
     *
     * @param event Event.
     */
    onMouseDown(event) {
        event.preventDefault();
        if (this.hasFocus) {
            this.hasFocus = false;
            this.update();
        }
    }
    /**
     * Event handler.
     *
     * @param index ...
     */
    onFocusIn(index) {
        this.hasFocus = true;
        this.focusIndex = index;
        this.update();
    }
    /**
     * Event handler.
     */
    onFocusOut() {
        this.hasFocus = false;
        this.update();
    }
}
__decorate([
    property({ type: Object })
], Toggle.prototype, "items", void 0);
__decorate([
    property({ type: Number })
], Toggle.prototype, "selectedIndex", void 0);
__decorate([
    property({ type: Boolean })
], Toggle.prototype, "fluidWidth", void 0);
__decorate([
    property({ type: Boolean })
], Toggle.prototype, "disabled", void 0);
__decorate([
    property({ type: Object, required: true })
], Toggle.prototype, "theme", void 0);
__decorate([
    property({ type: String })
], Toggle.prototype, "ariaLabel", void 0);
//# sourceMappingURL=Toggle.js.map